import React from "react"
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Img from 'gatsby-image'
import { rhythm } from "../utils/typography"

import capitalize from 'capitalize'
import presets from '../utils/presets'

import Section from '../com/Section'
import Background from '../com/Background'
import Crosshairs from '../com/Crosshairs'
import Content from '../com/Content'
import Title from '../com/Title'
import Tag from '../com/Tag'
import Cta from '../com/Cta'
import P from '../com/P'
import SeeGrid from '../com/SeeGrid'
import H1 from '../com/H1'
import H2 from '../com/H2'

const SeePage = ({ data }) => (
<div>
  <Helmet>
    <title>See what we're making | SUPERFRAME</title>
    <meta name="description" content="Just some of the computer generated videos and images we produce at SUPERFRAME." />
  </Helmet>

  <h2 style={{
  textAlign:`center`,
  textTransform:`capitalize`,
  margin:`0`,
  padding:`${rhythm(3)} 0`,
}}>
what we&apos;re making</h2>

  <SeeGrid>
    {data.allSeeYaml.edges.map(({ node }) => (
      <Link
        key={node.id}
        to={`${node.fields.slug}`}
        style={{position:`relative`}}
        alt={node.title}
        title={node.title}>
          <Img
            sizes={node.image.childImageSharp.sizes}
            position={'relative'}
            alt={node.title}
          />
          <Tag>{capitalize(node.title)}</Tag>

          {(node.video != null ?
            <P brand
              style={{
                position:`absolute`,
                top:`0`,
                left:`0`,
                fontSize:`${rhythm(0.5)}`,
                marginTop:`${rhythm(0.25)}`,
                marginLeft:`${rhythm(0.25)}`,
              }}>[video]
            </P> : "" )}
      </Link>
      ))}
  </SeeGrid>
  <div style={{textAlign:`center`,}}>
    {/* <Cta to="/contact/">say hi</Cta> */}
  </div>
</div>
);

export default SeePage

export const query = graphql`
  query SeePageQuery {
    allSeeYaml(sort: {order : DESC, fields:[date]}){
      edges{
        node{
          id
          title
          date (formatString: "DD MMM YYYY")
          image{
            childImageSharp{
              sizes (maxWidth: 1280){
                sizes
                base64
                src
                srcSet
              }
            }
          }
          fields{
            slug
          }
          video{id}
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/see.js